import request from "@/plugins/axios";

// 工单单列表
export const apiWorkorderList = (params: any) =>
  request.get("/help.workOrder/lists", { params });

//工单类型
export const apiWorkorderEnum = () => request.get("/help.workOrder/enum");

//工单详情
export const apiWorkorderDetail = (params: any) =>
  request.get("/help.workOrder/detail", { params });

//工单回复
export const apiWorkorderReply = (params: any) =>
  request.post("/help.workOrder/reply", params);

//工单变更状态
export const apiWorkorderChangeStatus = (params: any) =>
  request.post("/help.workOrder/updateStatus", params);

//未读工单
export const apiWorkorderUnread = () =>
  request.get("/help.workOrder/unreadCount");

//统计
export const apiWorkorderStatistics = () =>
  request.get("/help.workOrder/statistics");

//指定管理员处理
export const apiWorkorderAssignAdmin = (params: any) =>
  request.post("/help.workOrder/assign", params);
